"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Wrapper = _interopRequireDefault(require("../elements/Wrapper"));

var _styles = require("../styles");

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var textStyles = (0, _styledComponents.css)(["color:#fff;position:absolute;user-select:none;", ";> *{font-size:10px;}"], _styles.centerY);

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "ToggleSwitch___StyledWrapper",
  componentId: "urxrnw-0"
})(["position:relative;transition:0.35s ", " background-color;"], _styles.easing);

var _StyledWrapper2 = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "ToggleSwitch___StyledWrapper2",
  componentId: "urxrnw-1"
})(["left:0;position:absolute;top:50%;transform:translate(", ",-50%);transition:0.35s ", " transform;z-index:2;"], function (p) {
  return p._css;
}, _styles.easing);

function ToggleSwitch(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["value", "onChange"]);

  return /*#__PURE__*/_react["default"].createElement(_StyledWrapper, _extends({
    onClick: function onClick() {
      return onChange(!value);
    },
    background: value && (0, _polished.lighten)(0.3, _styles.primary) || _styles.greyAlt,
    borderRadius: '25px',
    height: 12,
    width: 40
  }, props), /*#__PURE__*/_react["default"].createElement(_StyledWrapper2, {
    background: _styles.black,
    borderRadius: '50%',
    height: 20,
    width: 20,
    _css: value && '100%' || '0'
  }));
}

var _default = ToggleSwitch;
exports["default"] = _default;